import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsBar = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats?.map((stat, index) => (
        <div key={index} className="card p-6">
          <div className="flex items-center gap-4">
            <div className="h-12 w-12 rounded-lg flex items-center justify-center"
                 style={{ backgroundColor: `${stat?.color}15` }}>
              <Icon name={stat?.icon} size={24} color={stat?.color} />
            </div>
            <div className="flex-1">
              <p className="text-sm text-muted-foreground mb-1 font-caption">{stat?.label}</p>
              <p className="text-2xl font-bold text-foreground font-heading">{stat?.value}</p>
              {stat?.change && (
                <div className="flex items-center gap-1 mt-1">
                  <Icon 
                    name={stat?.change?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                    size={14} 
                    color={stat?.change?.trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'} 
                  />
                  <span className="text-xs font-caption" 
                        style={{ color: stat?.change?.trend === 'up' ? 'var(--color-success)' : 'var(--color-error)' }}>
                    {stat?.change?.value}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsBar;